export const postMessageEvents = {
  FM_doLogout: 'FM_doLogout',
  FM_embedReady: 'FM_embedReady',
  FM_redirectToProfile: 'FM_redirectToProfile',
  FM_mailerEmails: 'FM_mailerEmails',
}

// {type, ...}
export function sendParentPostMessage(data) {
  window.parent.postMessage(data, '*')
}
